import React from "react";
import "./MarketingFeatures.css";

function MarketingFeatures() {
  const features = [
    {
      title: "SEO Tools",
      description:
        "Improve your search rankings with keyword planning, meta optimization, sitemap support, and SEO improvement workflows.",
      button: "Explore SEO",
      icon: "🔍",
    },
    {
      title: "Email Campaigns",
      description:
        "Create promotional emails, build engagement, and stay connected with your customers through newsletter campaigns.",
      button: "Create Campaign",
      icon: "📧",
    },
    {
      title: "Brand Promotion",
      description:
        "Strengthen your online identity with branding strategy, content ideas, and digital promotion support.",
      button: "Promote Brand",
      icon: "📣",
    },
  ];

  return (
    <section className="marketing-section mf-section">
      <div className="marketing-container mf-container">
        <div className="marketing-section-heading mf-heading">
          <span className="marketing-section-badge mf-badge">Core Features</span>

          <h2 className="marketing-section-title mf-title">
            Everything You Need to Market Better
          </h2>

          <p className="marketing-section-text mf-text">
            Simple and practical tools to help your business improve visibility,
            trust, and customer reach.
          </p>
        </div>

        <div className="marketing-features-grid mf-grid">
          {features.map((item, index) => (
            <div className="marketing-feature-card mf-card" key={index}>
              <div className="marketing-feature-icon mf-icon">
                <span>{item.icon}</span>
              </div>

              <h3>{item.title}</h3>
              <p>{item.description}</p>

              <a
                href="#marketing-newsletter-form"
                className="marketing-feature-link marketing-btn-link mf-link"
              >
                {item.button}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MarketingFeatures;